import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/notification/mutations'
import { path } from '@/store/notification/types'
import { mutation } from '@/utils/mutation'
import state, { INotificationState } from '@/store/notification/state'

export * from '@/store/notification/state'

export const store: Module<INotificationState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
